import axios from 'axios';

// When running locally in dev mode, relative '/api' routes through setupProxy.js directly to the live server.
// If REACT_APP_API_URL is specified (e.g. for standalone build), it will use that base URL.
const rawUrl = process.env.REACT_APP_API_URL || '';
export const API_URL = rawUrl.replace(/\/+$/, '');

const API = axios.create({
  baseURL: API_URL ? `${API_URL}/api` : '/api',
  headers: { 'Content-Type': 'application/json' }
});

export const UPLOADS_URL = API_URL ? `${API_URL}/uploads` : '/uploads';

export default API;
